﻿<div class="form-component">
    <h4>
        Define Premium Data Rows to Import
    </h4>

    <form #form="ngForm">
        <!-- Header Index -->
        <div class="input-field">
            <label for="headerRow">
                Header Row:<span class="required">*</span>
            </label>
            <div>
                <input type="number" id="headerRow" name="headerRow" class="header" [(ngModel)]="model.headerIndex" min="1" required />
                <p class="error-message" *ngIf="form.submitted && form.invalid">
                    Header Row is required.
                </p>
            </div>
        </div>

        <!-- Start Row Index -->
        <div class="input-field">
            <label for="startRow">
                Start Row:<span class="required">*</span>
            </label>
            <div>
                <input type="number" id="startRow" name="startRow" class="start" [(ngModel)]="model.startIndex" required>
                <p class="error-message" *ngIf="form.submitted && form.invalid">
                    Start Row is required.
                </p>
            </div>
        </div>

        <!-- End Row Index -->
        <div class="input-field">
            <label for="endRow">
                End Row:<span class="required">*</span>
            </label>
            <div>
                <input type="number" id="endRow" name="endRow" class="end" [(ngModel)]="model.endIndex" required>
                <p class="error-message" *ngIf="form.submitted && form.invalid">
                    End Row is required.
                </p>
            </div>
        </div>
    </form>
</div>

<h3> Excel Data Preview </h3>

<div class="data-preview-container" *ngIf="!loading && (firstTenRows.length > 0 || lastTenRows.length > 0); else loadingOrNoData">
    <table class="data-preview-table">
        <thead>
            <tr [class.header-row]="firstTenRows[0]?.rowNumber === model.headerIndex">
                <th>{{firstTenRows[0]?.rowNumber}}</th>
                <th *ngFor="let header of firstTenRows[0]?.rowValues">{{ header || '' }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of firstTenRows.slice(1)" [class.header-row]="row?.rowNumber === model.headerIndex" [class.start-row]="row?.rowNumber === model.startIndex" [class.end-row]="row?.rowNumber === model.endIndex">
                <td>{{row?.rowNumber}}</td>
                <td *ngFor="let cell of row?.rowValues; let i = index">
                    {{ cell || '' }}
                </td>
            </tr>

            <tr>
                <td [attr.colspan]="firstTenRows[0]?.rowValues?.length || 1"></td>
            </tr>

            <tr *ngFor="let row of lastTenRows" [class.header-row]="row?.rowNumber === model.headerIndex" [class.start-row]="row?.rowNumber === model.startIndex" [class.end-row]="row?.rowNumber === model.endIndex">
                <td>{{row?.rowNumber}}</td>
                <td *ngFor="let cell of row?.rowValues; let i = index">
                    {{ cell || '' }}
                </td>
            </tr>
        </tbody>
    </table>
</div>

<ng-template #loadingOrNoData>
    <div *ngIf="loading" class="loading-indicator">
        <div class="spinner"></div>
        Loading Excel data... This may take a moment for larger files.
    </div>
    <ng-container *ngIf="!loading">
        <p>No data available to preview. Please verify your selections.</p>
    </ng-container>
</ng-template>
